import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from '../flow/ExecutionElement'
import { ElementLabel } from './ElementLabel'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import { Checkbox } from '../../../shared/webcomponents/react-wrappers/Checkbox'
import type { CreateAnswer } from '../../../shared/domain/flows/answer.no-deps'
import type { TimelineDetails } from './TimelineDetails'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    label: string
    timelineDetails: TimelineDetails
    required: boolean
    answerValue: Flows.ConfirmationAnswer['value']
    validationMessages: string[]
    createAnswer: CreateAnswer<Flows.ConfirmationAnswer>
    openOptions?: () => void
}

export function ElementConfirmation(props: Props) {
    const tryRender = () => {
        const { deps, elementId, label, timelineDetails, required, validationMessages, createAnswer } = props
        const isConfirmed = props.answerValue === true
        const onClick = () =>
            createAnswer((base) => ({
                ...base,
                type: 'confirmation',
                value: isConfirmed ? null : true,
            }))

        return (
            <ExecutionElement
                deps={deps}
                elementId={elementId}
                loopPathIds={props.loopPathIds}
                validationMessages={validationMessages}
                timelineDetails={timelineDetails}
            >
                <div className="AppCore__flow__ElementConfirmation">
                    <div className="AppCore__flow__ElementConfirmation__inputWrapper">
                        <Checkbox id={elementId} selected={isConfirmed} onChange={onClick} />
                        <ElementLabel
                            onClick={onClick}
                            required={required}
                            label={label}
                            hasBeenEdited={timelineDetails && timelineDetails.hasBeenEdited}
                            language={deps.language}
                            id={elementId}
                            validationMessages={validationMessages}
                            openOptions={props.openOptions}
                        />
                    </div>
                </div>
            </ExecutionElement>
        )
    }

    return renderCatch(props.deps, tryRender)
}
